import type { RouteObject } from "react-router-dom";
import { PagesUserPermissionsManagerParentUiDisplay } from ".";
export const PagesUserPermissionsManagerUiRoutes: RouteObject[] = [
  {
    path: "userPermissionsManager/:userId?",
    element: <PagesUserPermissionsManagerParentUiDisplay />
  }
];
